import { offsetLimitPagination } from "@apollo/client/utilities";

const queryArgs = ["order_by", "where"];
export default {
  history_fi_hist_international_dressage: offsetLimitPagination(queryArgs),
  history_fi_hist_international_driving: offsetLimitPagination(queryArgs),
  history_fi_hist_international_eventing: offsetLimitPagination(queryArgs),
  history_fi_hist_international_showjumping: offsetLimitPagination(queryArgs),

  history_fi_hist_officials: offsetLimitPagination(queryArgs),

  history_fi_hist_results_1985_1995: offsetLimitPagination(queryArgs),
  history_fi_hist_results_1996_2001: offsetLimitPagination(queryArgs),

  history_fi_hist_results_dressage: offsetLimitPagination(queryArgs),
  history_fi_hist_results_driving: offsetLimitPagination(queryArgs),
  history_fi_hist_results_endurance: offsetLimitPagination(queryArgs),
  history_fi_hist_results_eventing: offsetLimitPagination(queryArgs),
  history_fi_hist_results_icelandic: offsetLimitPagination(queryArgs),
  history_fi_hist_results_showjumping: offsetLimitPagination(queryArgs),
  history_fi_hist_results_paradressage: offsetLimitPagination(queryArgs),
  history_fi_hist_results_vaulting: offsetLimitPagination(queryArgs),
  history_fi_hist_results_western: offsetLimitPagination(queryArgs)
};
